var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcebergSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 92,
    viewBox: "0 0 49 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_745_36842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80105 12.299C8.58103 14.7933 8.08234 19.8716 7.84766 20.2308H42.463L36.376 19.4077L35.2759 15.2921L33.0025 12.299L29.0422 10.9521L26.5488 5.26519L23.1752 4.36726L16.3548 1L14.7414 2.42173H12.6146L8.80105 12.299Z",
    fill: "#3EFCFC",
    stroke: "#3EFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6381 20.2305H8.13429C7.78255 20.2305 7.43377 20.2947 7.10509 20.4199C5.72366 20.9463 4.96211 22.4303 5.33993 23.8595L5.91351 26.0293C6.18287 27.0483 6.14731 28.1239 5.81121 29.1228L5.18537 30.983C4.41344 33.2774 4.35798 35.7523 5.02637 38.079L6.22753 42.2603C6.59256 43.531 6.81648 44.838 6.89526 46.1577L7.48553 56.0463C7.56308 57.3455 7.79175 58.6312 8.1669 59.8775C8.63846 61.4439 8.87805 63.071 8.87805 64.7069V68.8548C8.87805 69.8283 9.15105 70.7822 9.66604 71.6083L10.0628 72.2447C10.3185 72.6549 10.454 73.1285 10.454 73.6118C10.454 74.1923 10.6495 74.756 11.009 75.2118L11.8967 76.3376C12.1849 76.7031 12.4344 77.0976 12.641 77.5146L13.8373 79.929C14.1782 80.617 14.6827 81.2108 15.3066 81.6584C16.104 82.2305 17.0607 82.5382 18.042 82.5382H19.647C20.4569 82.5382 21.2511 82.3144 21.942 81.8917L22.194 81.7375C22.9922 81.249 23.5727 80.473 23.8159 79.5694C23.9617 79.0278 24.2301 78.5271 24.6004 78.1059L25.3572 77.245C25.8264 76.7112 26.3602 76.2379 26.9463 75.8359L29.1491 74.325C30.9789 73.0699 32.5609 71.4874 33.8153 69.6571L34.2382 69.04C35.433 67.2966 36.3052 65.3528 36.8131 63.3011L37.6903 59.7579C37.8904 58.9495 37.8657 58.1018 37.6187 57.3064C37.2821 56.2228 37.3611 55.0526 37.8403 54.024L37.9962 53.6893L38.6717 51.533L41.8657 44.3C42.8772 42.0093 43.3996 39.5329 43.3996 37.0288V34.5062L43.8514 28.5195C43.9502 27.2107 43.9055 25.8951 43.7182 24.5961L43.4385 22.656C43.4126 22.4769 43.3697 22.3007 43.3102 22.1298C42.9144 20.9926 41.8422 20.2305 40.6381 20.2305Z",
    fill: "#1EC6C4",
    stroke: "#1EC6C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_745_36842",
    x: 0.0625,
    y: 0.40332,
    width: 48.3398,
    height: 90.6349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_745_36842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_745_36842",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcebergSm);
export default __webpack_public_path__ + "static/media/iceberg_sm.be74156bf82b3b2a9be9e8aee28877e7.svg";
export { ForwardRef as ReactComponent };